/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import s from './ImgModal.module.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    border: 'none',
    backgroundColor: 'rgba(0,0,0,0)',
    padding: '10px',
    maxHeight: '100vh'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.7)',
    zIndex: '1000'
  }
};

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#catalog');

const ImgModal = props => {
  const [showModal, setShowModal] = useState(false);
  const { image } = props;

  if (showModal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'visible';
  }

  return (
    <div>
      <div className={s.thumbnail}>
        <img
          src={image.src}
          alt={image.alt}
          title={image.title}
          onClick={() => setShowModal(true)}
        />
      </div>
      <Modal isOpen={showModal} style={customStyles}>
        <div className={s.modal}>
          <div>
            <div className={s.btnClose} onClick={() => setShowModal(false)}>
              <CloseIcon style={{ fontSize: '2rem' }} />
            </div>
            <img src={image.src} alt={image.alt} title={image.title} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ImgModal;
